<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
       <div class="mb25 m-t-25 s_flex_bian_c">
        <div>
          <span class='mr15'>
            <a-button type="primary" v-has:salesmanCreate="()=> {$router.push('/customer/salesman/salesmanCreate?type=add')}">
              <PlusOutlined />
              添加业务员
            </a-button>
          </span>
        </div>
        <div>
          <span>
            <a-button type="primary" ghost v-has:salesmanUrl="()=>getLink(6)">
              业务员登录地址
            </a-button>
          </span>
        </div>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" 
        :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键字" name='keywords'>
          <a-input  v-model:value="search.keyword" placeholder="关键字" />
        </a-form-item>
        <a-form-item label="状态" name='status'>
          <a-select v-model:value="search.status" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option value="1">正常</a-select-option>
            <a-select-option value="0">禁用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="创建日期" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered 
        :columns='columns'
        :data-source='data' class="tableFixBox" >
        <template v-slot:status="{ record }">
          <p>{{record.status?'正常':'禁用'}}</p>
        </template>
        <template v-slot:action="{ record }">
          <a-dropdown>
            <a class="ant-dropdown-link"> 操作
              <DownOutlined />
            </a>
            <template v-slot:overlay>
              <a-menu>
                <a-menu-item>
                  <a v-has:salesmanDetail="()=> {$router.push('/customer/salesman/salesman_detail?type=look&id='+record.id)}"
                    href="javascript:;">详情</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:salesmanEdit="()=> {$router.push('/customer/salesman/salesman_edit?type=edit&id='+record.id)}"
                    href="javascript:;">修改</a>
                </a-menu-item>
                <a-menu-item>
                  <a v-has:salesmanStatus="()=>dealerDisable(record)" href="javascript:;">{{record.status?'禁用':'启用'}}</a>
                </a-menu-item>
                <a-menu-item v-if="!record.status">
                  <a v-has:salesmanDel="()=>delDealer(record)" href="javascript:;">删除</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
      <a-modal  :keyboard="false" title="复制链接" centered :width='600' :footer="null" v-model:visible="visibleUrl" destroyOnClose>
    <div class="s_flex_bian_c">
      <div class="s_bor_r_cd9 p-r-20">
        <img class="width-160 height-160" :src="link.image" alt="">
        <p class="text-ac m-t-10">微信扫一扫立即预览</p>
      </div>
      <div class="width63">
        <p class="s_c333 s_font_b fz-16">复制地址</p>
        <div class="m-t-15 m-b-15 s_flex_bian_c">
          <a-input class="width80" v-model:value="link.link" readonly></a-input>
          <a-button type="primary" ghost @click="copy(link.link)">复制</a-button>
        </div>
        <p class="s_c999 ">可将链接复制到您的公众号菜单中</p>
      </div>
    </div>
  </a-modal>
  </a-layout>
</template>
<script>
  import { DownOutlined, PlusOutlined, EditOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs, h, createVNode } from "vue";
  import { message } from "ant-design-vue";
  import {getBrandSale,uBrandSaleEnable,uBrandSaleDel} from '@/api/salesman'
  import { getClientsite } from '@/api/public'
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defSearch = {
    page: 1,
    limit: 8,
    status: '',
    level_id: '',
    start_time: '',
    end_time: '',
    type: 'all'
  };
  export default {
    components: { DownOutlined, PlusOutlined },
    setup(props, ctx) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      let form = ref()
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        visibleUrl: false,
        listId: [],
        levelList: [],
        listLoading: false,
        time: [],
        total: 1,
        selectedRowKeys: [],
        link: {
          image: '',
          link: ''
        },
        level:null,
        confirmLoadingLink:false
      });
      let columns = [
        {
          title: "业务员编号",
          dataIndex: "sale_sn",
          key: "sale_sn",
        },
        {
          title: "业务员名称",
          dataIndex: "sale_name",
          key: "sale_name",
        },
        {
          title: "登录账号",
          dataIndex: "account",
          key: "account",
        },
        {
          title: "职级",
          dataIndex: "sale_rank_name",
          key: "sale_rank_name",
        },
        {
          title: "状态",
          dataIndex: "status_text",
          key: "status_text",
        },
        {
          title: "创建时间",
          dataIndex: "created_at",
          key: "created_at",
        },
        {
          title: "最后登录时间",
          dataIndex: "last_login_time",
          key: "last_login_time",
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')

      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      // 时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
        initData(search.value);
      }
      // 禁用启用业务员
      const dealerDisable = (e) => {
        $Modal.confirm({
          centered: true,
          title: e.status ? '禁用业务员' : '启用业务员',
          icon: createVNode(ExclamationCircleOutlined),
          onOk: async () => {
            let res = await uBrandSaleEnable(e.id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      //删除经销商
      const delDealer = (e) => {
        $Modal.confirm({
          centered: true,
          title: '业务员删除',
          content: '删除后该业务员将无法恢复，您确定要删除该业务员吗？', onOk: async () => {
            let res = await uBrandSaleDel(e.id).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            } else {
              message.error(res.msg);
            }
          }
        })
      }
      const initData = async (values) => {
        state.listLoading = true;
        data.value = []
        try {
          let res = await getBrandSale(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        initData(search.value);
      });
          // 获取地址
      const getLink = async (client_type) => {
        let result = await getClientsite({ client_type }).then(res => res.data).catch(error => error)
        state.link = result.data
        state.visibleUrl = true
      }
            // 复制
      const copy = (link) => {
        var input = document.createElement("input"); // 直接构建input
        input.value = link; // 设置内容
        document.body.appendChild(input); // 添加临时实例
        input.select(); // 选择实例内容
        document.execCommand("Copy"); // 执行复制
        document.body.removeChild(input); // 删除临时实例
        message.success("复制成功");
      };
      return {
        ...toRefs(state),
        search,
        form,
        data,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange,
        dealerDisable,
        delDealer,
        getLink,
        copy
      };
    },
  };
</script>